import { Api } from "../api";

export const fetchSales = async (completed, page, perPage, from, to, type = "Glass", saleInvoiceId = "") => {
    try {
        // console.log(type)
        const response = await Api.get("/sales", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            params: {
                completed,
                page,
                perPage,
                from,
                to,
                glassType: type,
                saleInvoiceId
            }
        });
        const salesData = response?.data?.data?.data || [];
        return { data: salesData, total: response.data?.saleCount };

    } catch (error) {
        console.log("errrr : ",error)

        if (error.response.status == 401) {
            localStorage.removeItem("token")
            window.location.href = "/"
        }
        console.error("Error fetching sales data:", error);
        return []; // Return an empty array in case of an error
    }
};

export const fetchCancelledSales = async (page, perPage, from, to) => {
    try {
        const response = await Api.get("/cancelled-sales", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            params: {
                page,
                per_page: perPage,
                from,
                to
            }
        });
        const salesData = response?.data?.data || [];
        // console.log("response cancelled sales : ", response)
        // console.log("salesData cancelled sales : ", response?.data)
        return { data: salesData, total: response.data?.total };

    } catch (error) {
        console.log("erorr : ",error)
        if (error.response.status == 401) {
            localStorage.removeItem("token")
            window.location.href = "/"
        }
        console.error("Error fetching sales data:", error);
        return []; // Return an empty array in case of an error
    }
};
